// ===== Bonanza Sleep — Shopify Theme JS =====

// --- Countdown Timer ---
function initCountdown() {
  document.querySelectorAll('[data-countdown]').forEach(function(el) {
    var hours = parseInt(el.dataset.hours) || 12;
    var hEl = el.querySelector('[data-cd-h]');
    var mEl = el.querySelector('[data-cd-m]');
    var sEl = el.querySelector('[data-cd-s]');
    if (!hEl) return;

    var key = 'ador_countdown_' + el.dataset.countdown;
    var end = sessionStorage.getItem(key);
    if (!end) {
      end = Date.now() + hours * 3600000;
      sessionStorage.setItem(key, end);
    }
    end = parseInt(end);

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      hEl.textContent = String(h).padStart(2, '0');
      mEl.textContent = String(m).padStart(2, '0');
      sEl.textContent = String(s).padStart(2, '0');
      if (diff > 0) requestAnimationFrame(tick);
    }
    tick();
    setInterval(tick, 1000);
  });
}

// --- Copy Promo Code ---
function copyCode(btn) {
  var code = btn.textContent.trim();
  if (navigator.clipboard) {
    navigator.clipboard.writeText(code).then(function() { showToast('Code "' + code + '" copied!'); });
  } else {
    showToast('Code: ' + code);
  }
}
window.copyCode = copyCode;

// --- Toast ---
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2800);
}
window.showToast = showToast;

// --- Cart Drawer ---
var _colorSwatchMap = {};

function registerColorSwatch(name, imgUrl) {
  if (name && imgUrl) _colorSwatchMap[name.toLowerCase().trim()] = imgUrl;
}
window.registerColorSwatch = registerColorSwatch;
function openDrawer() {
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('open');
  document.body.classList.add('menu-open');
  refreshCartDrawer();
}
function closeDrawer() {
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.classList.remove('menu-open');
}
window.openDrawer = openDrawer;
window.closeDrawer = closeDrawer;

var _cartCurrency = '£';

function formatMoney(cents) {
  return _cartCurrency + (cents / 100).toFixed(2);
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (cart.currency) {
        var cur = cart.currency;
        var symbols = { USD: '$', GBP: '£', EUR: '€', CAD: 'C$', AUD: 'A$', NZD: 'NZ$', JPY: '¥' };
        _cartCurrency = symbols[cur] || cur + ' ';
      }
      updateCartCount(cart.item_count);
      var body = document.getElementById('drawerBody');
      var total = document.getElementById('drawerTotal');
      var count = document.getElementById('drawerCount');
      if (!body) return;
      count.textContent = cart.item_count;
      total.textContent = formatMoney(cart.total_price);
      if (cart.items.length === 0) {
        body.innerHTML = '<p style="text-align:center;padding:40px 0;color:#888;">Your basket is empty</p>';
        return;
      }
      /* Group bundle children directly under their parent bed (children may arrive before the parent) */
      var grouped = [];
      var usedKeys = {};
      cart.items.forEach(function(it) {
        var pr = it.properties || {};
        if (pr['_bundle_parent'] && !usedKeys[it.key]) {
          usedKeys[it.key] = true;
          grouped.push(it);
          var ref = pr['_bundle_parent'];
          cart.items.forEach(function(ch) {
            var cp = ch.properties || {};
            if (cp['_bundle_ref'] === ref && !cp['_bundle_parent'] && !usedKeys[ch.key]) {
              usedKeys[ch.key] = true;
              grouped.push(ch);
            }
          });
        }
      });
      cart.items.forEach(function(it) { if (!usedKeys[it.key]) grouped.push(it); });

      function childRowHtml(item) {
        var imgSrc = item.image || '';
        if (item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;
        var productTitle = item.product_title || item.title;
        var itemKey = item.key || ('' + item.id);
        var variantHtml = '';
        if (item.variant_options && item.variant_options.length) {
          var vo = item.variant_options.filter(function(o) { return o && o !== 'Default Title'; });
          if (vo.length) variantHtml = '<span class="drawer-child-variant">' + vo.join(' / ') + '</span>';
        }
        return '<div class="drawer-child" data-key="' + itemKey + '">' +
          '<div class="drawer-child-img" style="background-image:url(' + imgSrc + ')"></div>' +
          '<div class="drawer-child-info">' +
            '<span class="drawer-child-title">' + productTitle + '</span>' +
            variantHtml +
          '</div>' +
          '<div class="drawer-child-price">' + formatMoney(item.line_price) + '</div>' +
          '<button type="button" class="drawer-child-remove" onclick="removeDrawerItem(\'' + itemKey + '\')">Remove</button>' +
        '</div>';
      }

      function renderDrawerItem(item, childrenHtml) {
        var properties = item.properties || {};
        var propKeys = Object.keys(properties).filter(function(name) {
          return name.charAt(0) !== '_' && properties[name] && name !== 'Color';
        });
        /* Combine the fabric descriptor with its colour line, e.g.
           { 'Fabric Option': 'Coniston', 'Coniston': 'Blue' } -> keep only 'Coniston: Blue' */
        var lowerKeyMap = {};
        propKeys.forEach(function(name) { lowerKeyMap[name.toLowerCase().trim()] = true; });
        var colorProp = properties['Color'] || properties['color'] || '';
        var filteredKeys = propKeys.filter(function(name) {
          var val = String(properties[name]).toLowerCase().trim();
          if (val !== name.toLowerCase().trim() && lowerKeyMap[val]) return false;
          return true;
        });
        /* Find the fabric descriptor so we can fold the colour into it on one line, e.g. "Fabric: PVC Leather Black" */
        var fabricKey = null;
        filteredKeys.forEach(function(name) {
          var lower = name.toLowerCase().trim();
          if (lower === 'fabric' || lower === 'fabric option' || lower === 'fabric type') fabricKey = name;
        });
        var propertyHtml = filteredKeys.map(function(name) {
          var lower = name.toLowerCase();
          var label = (lower === 'fabric option' || lower === 'fabric type' || lower === 'fabric') ? 'Fabric' : name;
          var val = properties[name];
          if (name === fabricKey && colorProp) val = val + ' ' + colorProp;
          return '<div class="drawer-item-property"><span class="drawer-item-property-label">' + label + ':</span> <span class="drawer-item-property-value">' + val + '</span></div>';
        }).join('');

        var variantHtml = '';
        if (item.variant_options && item.variant_options.length > 0) {
          var validOpts = item.variant_options.filter(function(o) { return o && o !== 'Default Title'; });
          if (validOpts.length > 0) {
            variantHtml = '<div class="drawer-item-variants">' +
              validOpts.map(function(opt) { return '<span class="drawer-variant-tag">' + opt + '</span>'; }).join('') +
            '</div>';
          }
        }

        /* Colour is merged into the Fabric line above when a fabric metafield exists; otherwise show it standalone */
        var colorHtml = '';
        if (colorProp && !fabricKey) {
          var swatchUrl = _colorSwatchMap[colorProp.toLowerCase().trim()] || '';
          colorHtml = '<div class="drawer-item-color">';
          if (swatchUrl) {
            colorHtml += '<img class="drawer-color-swatch" src="' + swatchUrl + '" alt="' + colorProp + '" width="28" height="22">';
          }
          colorHtml += '<span class="drawer-color-name">' + colorProp + '</span></div>';
        }

        var imgSrc = item.image || '';
        if (item.featured_image && item.featured_image.url) imgSrc = item.featured_image.url;

        var productTitle = item.product_title || item.title;
        if (item.product_title && item.variant_title && item.variant_title !== 'Default Title') productTitle = item.product_title;

        var itemKey = item.key || ('' + item.id);

        return '<div class="drawer-item" data-key="' + itemKey + '">' +
          '<div class="drawer-item-img" style="background-image:url(' + imgSrc + ')"></div>' +
          '<div class="drawer-item-info">' +
            '<h4>' + productTitle + '</h4>' +
            variantHtml +
            colorHtml +
            (propertyHtml ? '<div class="drawer-item-properties">' + propertyHtml + '</div>' : '') +
            '<div class="drawer-item-foot">' +
              '<div class="price">' + formatMoney(item.line_price) + '</div>' +
              '<button type="button" class="drawer-item-remove" onclick="removeDrawerItem(\'' + itemKey + '\')">Remove</button>' +
            '</div>' +
            (childrenHtml || '') +
          '</div>' +
        '</div>';
      }

      var parentRefs = {};
      grouped.forEach(function(it) { var p = it.properties || {}; if (p['_bundle_parent']) parentRefs[p['_bundle_parent']] = true; });

      var drawerHtml = [];
      grouped.forEach(function(item) {
        var props = item.properties || {};
        var hasRef = Object.prototype.hasOwnProperty.call(props, '_bundle_ref');
        /* children render nested inside their parent; orphan children (no parent in cart) still show standalone */
        if (hasRef && parentRefs[props['_bundle_ref']]) return;
        var childrenHtml = '';
        if (props['_bundle_parent']) {
          var ref = props['_bundle_parent'];
          var rows = [];
          grouped.forEach(function(ci) {
            var cp = ci.properties || {};
            if (Object.prototype.hasOwnProperty.call(cp, '_bundle_ref') && cp['_bundle_ref'] === ref && !cp['_bundle_parent']) rows.push(childRowHtml(ci));
          });
          if (rows.length) childrenHtml = '<div class="drawer-item-children"><div class="drawer-item-children-label">Included with your bed</div>' + rows.join('') + '</div>';
        }
        drawerHtml.push(renderDrawerItem(item, childrenHtml));
      });
      body.innerHTML = drawerHtml.join('');
    });
}

function removeDrawerItem(key) {
  if (!key) return;
  /* If the removed item is a bundle parent, also remove all of its child add-ons (storage, mattress, assembly, ottoman, …) */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var updates = {};
      updates[key] = 0;
      var parent = cart.items.filter(function(i) { return i.key === key; })[0];
      if (parent && parent.properties && parent.properties['_bundle_parent']) {
        var ref = parent.properties['_bundle_parent'];
        cart.items.forEach(function(i) {
          if (i.properties && i.properties['_bundle_ref'] === ref && !i.properties['_bundle_parent']) updates[i.key] = 0;
        });
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      refreshCartDrawer();
      showToast('Item removed from basket');
    })
    .catch(function() { showToast('Error removing item'); });
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

// AJAX add to cart
function addToCart(variantId, qty) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(item) {
    showToast(item.title + ' added to basket');
    openDrawer();
  })
  .catch(function() { showToast('Error adding to basket'); });
}
window.addToCart = addToCart;

// --- Reviews Carousel ---
function initReviewCarousel() {
  document.querySelectorAll('.reviews-carousel').forEach(function(carousel) {
    var grid = carousel.querySelector('.reviews-grid');
    var left = carousel.querySelector('.review-arrow.left');
    var right = carousel.querySelector('.review-arrow.right');
    if (!grid) return;
    var scrollAmt = function() {
      var card = grid.querySelector('.review-card');
      return card ? card.offsetWidth + 18 : 300;
    };
    if (left) left.addEventListener('click', function() { grid.scrollBy({ left: -(scrollAmt() * 2), behavior: 'smooth' }); });
    if (right) right.addEventListener('click', function() { grid.scrollBy({ left: scrollAmt() * 2, behavior: 'smooth' }); });
  });
}

// --- Service Carousel ---
function initServiceCarousel() {
  document.querySelectorAll('[data-service-slider], .service-carousel').forEach(function(carousel) {
    var track = carousel.querySelector('.service-track');
    var left = carousel.querySelector('.service-arrow.left');
    var right = carousel.querySelector('.service-arrow.right');
    var dots = carousel.querySelectorAll('.service-dot');
    var ticking = false;
    if (!track) return;
    if (left) left.addEventListener('click', function() { track.scrollBy({ left: -300, behavior: 'smooth' }); });
    if (right) right.addEventListener('click', function() { track.scrollBy({ left: 300, behavior: 'smooth' }); });

    function setActiveDot(index) {
      dots.forEach(function(dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function updateDots() {
      ticking = false;
      if (!dots.length) return;
      var items = Array.prototype.slice.call(track.querySelectorAll('.service-item'));
      if (!items.length) return;
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var activeIndex = 0;
      var closest = Infinity;

      items.forEach(function(item, index) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var distance = Math.abs(center - itemCenter);
        if (distance < closest) {
          closest = distance;
          activeIndex = index;
        }
      });

      setActiveDot(activeIndex);
    }

    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        var item = track.querySelectorAll('.service-item')[index];
        if (item) item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        setActiveDot(index);
      });
    });

    track.addEventListener('scroll', function() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateDots);
    });
    window.addEventListener('resize', updateDots);
    updateDots();
  });
}

// --- Footer Accordion (mobile) ---
var _footerAccordionMedia = window.matchMedia('(max-width: 824px)');

function footerAccordionIsMobile() {
  return _footerAccordionMedia.matches;
}

function initFooterAccordions() {
  if (!window._bonanzaFooterAccordionMediaReady) {
    window._bonanzaFooterAccordionMediaReady = true;
    if (_footerAccordionMedia.addEventListener) {
      _footerAccordionMedia.addEventListener('change', syncFooterAccordions);
    } else {
      _footerAccordionMedia.addListener(syncFooterAccordions);
    }
  }
  syncFooterAccordions();
}

function syncFooterAccordions() {
  var isMobile = footerAccordionIsMobile();
  document.querySelectorAll('.site-footer .footer-accordion').forEach(function(group) {
    setFooterAccordionOpen(group, !isMobile);
  });
}

function setFooterAccordionOpen(group, open) {
  var toggle = group ? group.querySelector('.footer-accordion-toggle') : null;
  var panel = group ? group.querySelector('.footer-accordion-panel') : null;
  if (!group || !toggle) return;
  group.classList.toggle('is-open', open);
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (panel) panel.hidden = !open;
}

function toggleFooterAccordion(btn) {
  if (!footerAccordionIsMobile()) return;

  var group = btn.closest('.footer-accordion');
  if (!group) return;

  var shouldOpen = !group.classList.contains('is-open');
  document.querySelectorAll('.site-footer .footer-accordion').forEach(function(other) {
    setFooterAccordionOpen(other, false);
  });
  setFooterAccordionOpen(group, shouldOpen);
}
window.toggleFooterAccordion = toggleFooterAccordion;
document.addEventListener('shopify:section:load', initFooterAccordions);

// --- Mobile Menu ---
function openMobileMenu() {
  document.getElementById('mobileMenuDrawer').classList.add('open');
  document.getElementById('mobileMenuOverlay').classList.add('open');
  document.body.classList.add('menu-open');
}
function closeMobileMenu() {
  document.getElementById('mobileMenuDrawer').classList.remove('open');
  document.getElementById('mobileMenuOverlay').classList.remove('open');
  document.body.classList.remove('menu-open');
}
window.openMobileMenu = openMobileMenu;
window.closeMobileMenu = closeMobileMenu;

// --- Mobile Nav Accordion ---
function toggleMobileAccordion(btn) {
  var parent = btn.closest('.mobile-nav-parent');
  var children = parent ? parent.querySelector('.mobile-nav-children') : null;
  if (!children) return;
  var isOpen = children.classList.contains('open');
  // close all open accordions
  document.querySelectorAll('.mobile-nav-children.open').forEach(function(el) {
    el.classList.remove('open');
    var t = el.closest('.mobile-nav-parent').querySelector('.mobile-nav-toggle');
    if (t) t.classList.remove('open');
  });
  if (!isOpen) {
    children.classList.add('open');
    btn.classList.add('open');
  }
}
window.toggleMobileAccordion = toggleMobileAccordion;

// --- Mobile Search ---
function toggleMobileSearch() {
  document.body.classList.toggle('mobile-search-open');
  var input = document.querySelector('.search-wrap input');
  if (input && document.body.classList.contains('mobile-search-open')) input.focus();
}
window.toggleMobileSearch = toggleMobileSearch;

// --- Trust Bar Rotation (mobile) ---
// NOTE: The header trust bar now uses a scroll-snap slider with its own
// auto-play (see sections/header.liquid). This fade-rotation is kept only for
// any other .header-trust that lacks a slider; running both at once caused the
// mobile badges to blink.
function initTrustRotation() {
  document.querySelectorAll('.header-trust').forEach(function(bar) {
    if (bar.querySelector('.trust-viewport')) return; // slider owns this bar
    var items = bar.querySelectorAll('.trust-item');
    if (items.length < 2) return;
    var idx = 0;
    items[0].classList.add('active');
    setInterval(function() {
      items[idx].classList.remove('active');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('active');
    }, 3000);
  });
}

// --- Search Form (with predictive product suggestions) ---
function initSearch() {
  document.querySelectorAll('.search-wrap').forEach(function(wrap) {
    var form = wrap.closest('form');
    var input = wrap.querySelector('input');
    if (!input) return;

    // Predictive dropdown container
    var box = document.createElement('div');
    box.className = 'search-suggest';
    box.setAttribute('hidden', '');
    box.setAttribute('role', 'listbox');
    wrap.appendChild(box);

    var timer = null;
    var lastTerm = '';

    function close() { box.hidden = true; }

    function show(products) {
      if (!products || !products.length) {
        box.innerHTML = '<div class="search-suggest-empty">No products found</div>';
      } else {
        box.innerHTML = products.map(function(p) {
          var img = '';
          if (p.image) img = typeof p.image === 'string' ? p.image : (p.image.url || '');
          if (!img && p.featured_image) img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.url || '');
          var imgHtml = img
            ? '<img src="' + img + '" alt="" loading="lazy" width="40" height="40">'
            : '<span class="search-suggest-ph">🛏</span>';
          var url = p.url || (p.handle ? ('/products/' + p.handle) : '#');
          return '<a class="search-suggest-item" href="' + url + '">' +
                   '<span class="search-suggest-thumb">' + imgHtml + '</span>' +
                   '<span class="search-suggest-info">' +
                     '<span class="search-suggest-name">' + (p.title || '') + '</span>' +
                     (p.price ? '<span class="search-suggest-price">' + p.price + '</span>' : '') +
                   '</span>' +
                 '</a>';
        }).join('');
      }
      box.hidden = false;
    }

    input.addEventListener('input', function() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      clearTimeout(timer);
      timer = setTimeout(function() {
        if (q === lastTerm) return;
        lastTerm = q;
        fetch('/search/suggest.json?resources[type]=product&resources[limit]=8&q=' + encodeURIComponent(q), { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.ok ? r.json() : null; })
          .then(function(data) {
            var products = data && data.resources && data.resources.results && data.resources.results.products;
            var allow = window.__COLLECTED_PRODUCT_HANDLES || '';
            if (allow && products && products.length) {
              products = products.filter(function(p) {
                var h = p.handle || '';
                return h && allow.indexOf('|' + h + '|') !== -1;
              });
            }
            show(products || []);
          })
          .catch(function() { close(); });
      }, 200);
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { close(); input.blur(); }
    });

    // Fallback for wraps without a <form>: Enter runs a full product search
    if (!form) {
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          window.location.href = '/search?type=product&q=' + encodeURIComponent(input.value);
        }
      });
    }

    document.addEventListener('click', function(e) {
      if (!wrap.contains(e.target)) close();
    });
    if (form) form.addEventListener('submit', function() { close(); });
  });
}

// --- Cart Page AJAX ---
function initCartPage() {
  var cartPage = document.querySelector('.cart-page');
  if (!cartPage) return;

  // Quantity minus buttons
  cartPage.querySelectorAll('.qty-minus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('.qty-input');
      var newVal = parseInt(input.value) - 1;
      if (newVal < 0) return;
      input.value = newVal;
      updateCartItem(btn.dataset.key, newVal, btn.closest('[data-key]'));
    });
  });

  // Quantity plus buttons
  cartPage.querySelectorAll('.qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = btn.parentElement.querySelector('.qty-input');
      var newVal = parseInt(input.value) + 1;
      input.value = newVal;
      updateCartItem(btn.dataset.key, newVal, btn.closest('[data-key]'));
    });
  });

  // Quantity input change
  cartPage.querySelectorAll('.qty-input').forEach(function(input) {
    var debounceTimer;
    input.addEventListener('change', function() {
      var val = parseInt(input.value);
      if (isNaN(val) || val < 0) { input.value = 0; val = 0; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        updateCartItem(input.dataset.key, val, input.closest('[data-key]'));
      }, 400);
    });
  });

  // Remove buttons (AJAX)
  cartPage.querySelectorAll('.cart-remove-btn[data-key]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      var parentItem = link.closest('.cart-item');
      /* Removing a parent bed also removes its nested child add-ons (storage, mattress, ottoman, …) */
      if (parentItem && !link.closest('.cart-child')) {
        var updates = {};
        updates[link.dataset.key] = 0;
        parentItem.querySelectorAll('.cart-child[data-key]').forEach(function(ch) {
          if (ch.dataset.key) updates[ch.dataset.key] = 0;
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function() { window.location.reload(); });
        return;
      }
      updateCartItem(link.dataset.key, 0, link.closest('[data-key]'));
    });
  });
}

function updateCartItem(key, qty, itemEl) {
  if (!itemEl) return;
  itemEl.classList.add('updating');

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    if (qty === 0 && itemEl) {
      itemEl.style.transition = 'opacity .2s, max-height .3s';
      itemEl.style.opacity = '0';
      itemEl.style.maxHeight = '0';
      itemEl.style.overflow = 'hidden';
      itemEl.style.padding = '0';
      itemEl.style.margin = '0';
      setTimeout(function() {
        itemEl.remove();
        checkCartEmpty(cart);
        updateCartSummary(cart);
      }, 300);
    } else {
      // Update line total for this item
      var lineTotalEl = itemEl.querySelector('.cart-line-total');
      if (lineTotalEl) {
        var matchItem = cart.items.find(function(ci) { return ci.key === key; });
        if (matchItem) {
          lineTotalEl.textContent = formatMoney(matchItem.line_price);
        }
      }
      updateCartSummary(cart);
    }
    updateCartCount(cart.item_count);
    refreshCartDrawer();
    itemEl.classList.remove('updating');
  })
  .catch(function() {
    itemEl.classList.remove('updating');
    showToast('Error updating cart');
  });
}

function checkCartEmpty(cart) {
  if (cart.item_count === 0) {
    var layout = document.querySelector('.cart-layout');
    if (layout) {
      layout.innerHTML = '<div class="cart-empty">' +
        '<svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0 0 20 4H5.21l-.94-2H1z"/></svg>' +
        '<h2>Your basket is empty</h2>' +
        '<p>Looks like you have not added any items yet.</p>' +
        '<a href="/collections" class="main-btn">Continue Shopping</a>' +
        '</div>';
    }
  }
}

function updateCartSummary(cart) {
  var subtotalEl = document.querySelector('.cart-summary-row span:last-child');
  var totalEl = document.querySelector('.cart-total-row span:last-child');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

  var countText = document.querySelector('.cart-summary-row:first-child span:first-child');
  if (countText) countText.textContent = 'Subtotal (' + cart.item_count + (cart.item_count === 1 ? ' item)' : ' items)');
}

// --- Init ---
document.addEventListener('DOMContentLoaded', function() {
  initFooterAccordions();
  initCountdown();
  initReviewCarousel();
  initServiceCarousel();
  initTrustRotation();
  initSearch();
  initCartPage();

  // Load initial cart count
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { updateCartCount(cart.item_count); })
    .catch(function() {});
});
